import React from "react";
import { useForm } from "react-hook-form";
import { HrmFormInput } from "../components/hrm_input";
import { useFaq } from "../../contexts/faq-context";
import { yupResolver } from "@hookform/resolvers/yup";
import { addFaqValidation } from "../../validations/faq_validation";
import HrmLoader from "../components/hrm_loader";

const AddFaq = () => {

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm({ resolver: yupResolver(addFaqValidation) });



  const { onAddFaq, faqLoader } = useFaq();
  const onSubmit = async (values) => {
    await onAddFaq(values);
  }

  const handleReset = () => {
    reset();
  }
  return (
    <div>
      <div className="col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6">
        <h5 className="mb-2">Add FAQ</h5>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              {faqLoader ? (<HrmLoader />) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <HrmFormInput label={"Question"} placeholder={"Enter question"} error={errors?.question ? errors.question.message : ""} {...register("question")} />
                  <HrmFormInput label={"Answer"} placeholder={"Enter answer"} type="textarea" error={errors?.answer ? errors.answer.message : ""} {...register("answer")} />
                  <div className="flex justify-center gap-2 mt-4">
                    <button type="reset" className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10" onClick={handleReset}>Reset</button>
                    <button type="submit" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">Add Faq</button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>



      </div>
    </div>
  )
};

export default AddFaq;
